import React from "react";
import {
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBSwitch,
} from "mdb-react-ui-kit";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import "../ContactSection/ContactSection.css";
import "./AdminContactSection.css";

const FIELDS = [
  "name",
  "address",
  "email",
  "tagline",
  "social_instagram",
  "social_facebook",
  "social_youtube",
  "social_tiktok",
  "phone",
  "whatsapp",
  "form_enabled",
  "show_email",
  "show_social_instagram",
  "show_social_facebook",
  "show_social_youtube",
  "show_social_tiktok",
  "show_phone",
  "show_whatsapp",
];

const DEFAULTS = {
  name: "MUGIN",
  address: "I.E.S. Miguel de Mañara, Calle Cultura, s/n, La Rinconada",
  email: "MUGINsanjose@gmail.com",
  tagline: "Charlas, colaboraciones, funciones y talleres. ¡Hablemos!",
  social_instagram: "https://www.instagram.com/MUGINsj",
  social_facebook: "https://www.facebook.com/profile.php?id=100057086515415",
  social_youtube: "https://www.youtube.com/@teatroMUGIN",
  social_tiktok: "",
  phone: "",
  whatsapp: "",
  form_enabled: "true",
  show_email: "true",
  show_social_instagram: "true",
  show_social_facebook: "true",
  show_social_youtube: "true",
  show_social_tiktok: "true",
  show_phone: "true",
  show_whatsapp: "true",
};

class AdminContactSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: { ...DEFAULTS },
      original: { ...DEFAULTS },
      ids: {},
      loaded: false,
      saving: false,
    };
  }

  componentDidMount() {
    this.loadContact();
  }

  async loadContact() {
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch("MUGIN", "getSiteContentByPrefix?prefix=CONTACT_");
      const json = await response.json();
      const items = json && json.DATA ? json.DATA : [];
      if (items.length > 0) {
        const vals = { ...DEFAULTS };
        const ids = {};
        items.forEach((item) => {
          const key = item.contentKey.replace("CONTACT_", "");
          vals[key] = item.configValue ?? DEFAULTS[key] ?? "";
          ids[key] = item.IDContent ?? null;
        });
        this.setState({ values: vals, original: { ...vals }, ids, loaded: true });
      } else {
        this.setState({ loaded: true });
      }
    } catch (err) {
      console.error("Error loading contact data:", err);
      toast.show({ message: "Error al cargar datos de contacto", type: "danger" });
      this.setState({ loaded: true });
    } finally {
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  handleChange = (key, value) => {
    this.setState((prev) => ({
      values: { ...prev.values, [key]: value },
    }));
  };

  saveContact = async () => {
    this.setState({ saving: true });
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const { values, ids } = this.state;
      const payload = FIELDS.map((key) => ({
        IDContent: ids[key] ?? null,
        contentKey: "CONTACT_" + key,
        configValue: values[key] ?? "",
        contentType: "config",
      }));

      const response = await doFetch("MUGIN", "upsertSiteContentBatch", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await response.json();

      if (json.STATE === "SUCCESS") {
        toast.show({
          message: "Datos de contacto guardados",
          type: "success",
          position: "bottom-center",
          timeout: 3000,
        });
        const newIds = { ...ids };
        if (json.DATA) {
          json.DATA.forEach((item) => {
            const key = item.contentKey.replace("CONTACT_", "");
            newIds[key] = item.IDContent;
          });
        }
        this.setState({ original: { ...values }, ids: newIds });
      } else {
        toast.show({ message: json.MESSAGE || "Error al guardar", type: "danger" });
      }
    } catch (err) {
      console.error("Error saving contact data:", err);
      toast.show({ message: "Error de conexión al guardar", type: "danger" });
    } finally {
      this.setState({ saving: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  };

  discardChanges = () => {
    this.setState((prev) => ({ values: { ...prev.original } }));
  };

  hasChanges() {
    const { values, original } = this.state;
    return FIELDS.some((key) => values[key] !== original[key]);
  }

  buildMapSrc() {
    const addr = this.state.values.address;
    return `https://www.google.com/maps?q=${encodeURIComponent(addr)}&z=15&output=embed`;
  }

  render() {
    const { values, loaded, saving } = this.state;
    const dirty = this.hasChanges();

    if (!loaded) return null;

    return (
      <section className="contact-section admin-contact-section">
        {/* Toolbar */}
        <div className="admin-contact-toolbar">
          {dirty && (
            <MDBBtn color="secondary" size="sm" onClick={this.discardChanges} disabled={saving}>
              <MDBIcon fas icon="undo" className="me-1" /> Descartar
            </MDBBtn>
          )}
          <MDBBtn
            color="success"
            size="sm"
            onClick={this.saveContact}
            disabled={!dirty || saving}
          >
            <MDBIcon fas icon="save" className="me-1" />
            {saving ? "Guardando…" : "Guardar cambios"}
          </MDBBtn>
        </div>

        {/* Hero */}
        <div className="contact-hero">
          <div className="contact-hero-content">
            <h2 className="contact-title">
              <span className="contact-title-main">Contáctanos</span>
              <span className="contact-title-sub">
                —{" "}
                <MDBInput
                  className="inline-input d-inline-block"
                  style={{ width: "200px" }}
                  size="sm"
                  value={values.name}
                  onChange={(e) => this.handleChange("name", e.target.value)}
                />
              </span>
            </h2>
            <div className="contact-tagline">
              <MDBInput
                className="inline-input"
                size="sm"
                value={values.tagline}
                onChange={(e) => this.handleChange("tagline", e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Quick cards */}
        <MDBRow className="g-4 quick-cards">
          <MDBCol md="6">
            <MDBCard className="contact-card">
              <MDBCardBody>
                <MDBCardTitle>
                  <MDBIcon icon="map-marker-alt" className="me-2" /> Dirección
                </MDBCardTitle>
                <MDBInput
                  className="inline-input mb-2"
                  size="sm"
                  value={values.address}
                  onChange={(e) => this.handleChange("address", e.target.value)}
                />
                <a
                  className="link-accent"
                  href={`https://maps.google.com/?q=${encodeURIComponent(values.address)}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Ver en Google Maps
                </a>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
          <MDBCol md="6">
            <MDBCard className="contact-card">
              <MDBCardBody>
                <MDBCardTitle>
                  <MDBIcon icon="envelope" className="me-2" /> Email
                </MDBCardTitle>
                <MDBInput
                  className="inline-input mb-2"
                  size="sm"
                  value={values.email}
                  onChange={(e) => this.handleChange("email", e.target.value)}
                />
                <MDBBtn outline size="sm" tag="a" href={`mailto:${values.email}`}>
                  Escríbenos
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>

        {/* Main block: form placeholder + social editing */}
        <MDBRow className="g-4 align-items-stretch mt-1">
          <MDBCol lg="6">
            <MDBCard className="contact-card h-100">
              <MDBCardBody>
                <MDBCardTitle className="mb-3">Formulario de contacto</MDBCardTitle>
                <div className="d-flex align-items-center gap-2 mb-3">
                  <MDBSwitch
                    id="form-enabled-switch"
                    checked={values.form_enabled !== "false"}
                    onChange={(e) =>
                      this.handleChange("form_enabled", e.target.checked ? "true" : "false")
                    }
                  />
                  <label htmlFor="form-enabled-switch" className="mb-0">
                    {values.form_enabled !== "false"
                      ? "Formulario habilitado"
                      : "Formulario deshabilitado"}
                  </label>
                </div>
                <MDBCardText className="text-muted fst-italic">
                  El envío de mensajes se habilitará próximamente.
                </MDBCardText>

                {/* Social links editing */}
                <hr />
                <p className="field-group-label">Redes sociales</p>
                <MDBRow className="g-2">
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-instagram-switch"
                        checked={values.show_social_instagram !== "false"}
                        onChange={(e) => this.handleChange("show_social_instagram", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fab icon="instagram" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="Instagram URL"
                        value={values.social_instagram}
                        onChange={(e) => this.handleChange("social_instagram", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-facebook-switch"
                        checked={values.show_social_facebook !== "false"}
                        onChange={(e) => this.handleChange("show_social_facebook", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fab icon="facebook" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="Facebook URL"
                        value={values.social_facebook}
                        onChange={(e) => this.handleChange("social_facebook", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-youtube-switch"
                        checked={values.show_social_youtube !== "false"}
                        onChange={(e) => this.handleChange("show_social_youtube", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fab icon="youtube" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="YouTube URL"
                        value={values.social_youtube}
                        onChange={(e) => this.handleChange("social_youtube", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-tiktok-switch"
                        checked={values.show_social_tiktok !== "false"}
                        onChange={(e) => this.handleChange("show_social_tiktok", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fab icon="tiktok" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="TikTok URL"
                        value={values.social_tiktok}
                        onChange={(e) => this.handleChange("social_tiktok", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                </MDBRow>

                <hr />
                <p className="field-group-label">Email</p>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <MDBSwitch
                    id="show-email-switch"
                    checked={values.show_email !== "false"}
                    onChange={(e) => this.handleChange("show_email", e.target.checked ? "true" : "false")}
                    title="Mostrar/ocultar email"
                  />
                  <label htmlFor="show-email-switch" className="mb-0 small">Mostrar email</label>
                </div>

                <hr />
                <p className="field-group-label">Contacto directo</p>
                <MDBRow className="g-2">
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-phone-switch"
                        checked={values.show_phone !== "false"}
                        onChange={(e) => this.handleChange("show_phone", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fas icon="phone" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="Teléfono"
                        value={values.phone}
                        onChange={(e) => this.handleChange("phone", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                  <MDBCol xs="12">
                    <div className="d-flex align-items-center gap-2">
                      <MDBSwitch
                        id="show-whatsapp-switch"
                        checked={values.show_whatsapp !== "false"}
                        onChange={(e) => this.handleChange("show_whatsapp", e.target.checked ? "true" : "false")}
                        title="Mostrar/ocultar"
                      />
                      <MDBIcon fab icon="whatsapp" />
                      <MDBInput
                        className="inline-input flex-grow-1"
                        size="sm"
                        label="WhatsApp (número con prefijo)"
                        value={values.whatsapp}
                        onChange={(e) => this.handleChange("whatsapp", e.target.value)}
                      />
                    </div>
                  </MDBCol>
                </MDBRow>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>

          {/* Map */}
          <MDBCol lg="6">
            <div className="map-wrapper">
              <iframe
                title="Ubicación"
                src={this.buildMapSrc()}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </MDBCol>
        </MDBRow>
      </section>
    );
  }
}

export default AdminContactSection;
